import { EventBus } from '../eventBus'

export default {
  data () {
    return {
      unsubscribe: '',
      unsubscribeSingle: '',
      fetching: false,
    }
  },
  methods: {
    processChange (change) {
      try {
        return { id: change.doc.id, ...change.doc.data() }
      } catch (err) {
        console.log(err, 'err in processing')
        return false
      }
    },
    async fetchData (ref, localStore) {
      try {
        this.unsubscribe = ref.onSnapshot(areasSnapshot => {
          areasSnapshot.docChanges().forEach(change => {
            const id = change.doc.id
            const index = localStore.findIndex(item => item.id === id)
            if (change.type === this.firestoreChangeTypes.added) {
              if (localStore.findIndex(item => item.id === id) === -1) {
                localStore.push(this.processChange(change))
              }
            }
            if (change.type === this.firestoreChangeTypes.modified) {
              localStore.splice(index, 1, this.processChange(change))
            }
            if (change.type === this.firestoreChangeTypes.removed) {
              localStore.splice(index, 1)
            }
          })
        })
      } catch (err) {
        console.log(err)
      } finally {
        setTimeout(() => {
          this.fetching = false
        }, 1500)
      }
    },
    async fetchSingleData (ref, fallback) {
      try {
        this.unsubscribeSingle = ref.onSnapshot(doc => {
          let data = doc.data()
          data = doc.exists ? data : { ...fallback }
          EventBus.$emit('dataFetched', data)
        })
      } catch (err) {
        console.log(err)
        this.fetching = false
      }
    }
  },
  destroyed () {
    if (this.unsubscribe) { this.unsubscribe()}
    if (this.unsubscribeSingle) { this.unsubscribeSingle()}
  }
}